import { useBooleanState } from '@cian/react-utils';
import React, { FC, memo } from 'react';

import { AdFoxBannerContainer } from 'shared/containers/AdFoxBannerContainer';
import { BuzzoolaBannerContainer } from 'shared/containers/BuzzoolaBannerContainer';
import {
  useNewbuildingBuzzoolaIntegrationTestWebBuzzoolaGroup,
  useNewbuildingBuzzoolaIntegrationTestWebExpEnabled,
  useNewbuildingBuzzoolaIntegrationAsStubEnabled,
  useNewbuildingBuzzoolaFirstEnabled,
} from 'shared/hooks/experiments/useNewbuildingBuzzoolaIntegrationTestWebAvailable';
import { AdfoxContextProviderProps } from 'shared/utils/AdfoxContext';

/**
 * @todo Заменить типы
 * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
 * Если переходим на базуллу, то заменить на типы базуллы.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'Listing_native_TGB',
  extra__DEPRECATED: {
    offerType: 'TGB_banner',
  },
};
/**
 * @todo Заменить типы
 * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
 * Если переходим на базуллу, то заменить на типы базуллы.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 376 };
/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
 * Если переходим на базуллу, то удалить.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const P_PARAMS_NEWBUILDING: AdfoxContextProviderProps['pParams'] = { p1: 'davxz', p2: 'fkhj' };
/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
 * Если переходим на базуллу, то удалить.
 * Если остаёмся на адфоксе, то оставить как есть.
 */
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'ddcfw', p2: 'fkhj' };
/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
 * Если переходим на базуллу, то оставить как есть.
 * Если остаёмся на адфоксе, то удалить.
 */
const PLACEMENT_ID = 1298540;
/**
 * @todo Удалить переменную
 * @description Данный функционал появился в задаче CD-246118, будет удалён в задаче CD-245073
 * Если переходим на базуллу, то оставить как есть.
 * Если остаёмся на адфоксе, то удалить.
 */
const PLACEMENT_ID_NEWBUILDING = 1299040;

type TGBBannerProps = {
  isNewbuilding: boolean;
  position: number;
};

/**
 * @todo Удалить компонент
 * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
 */
export const TGBBannerExp: FC<TGBBannerProps> = props => {
  const { isNewbuilding, position } = props;

  const isBuzzoolaGroup = useNewbuildingBuzzoolaIntegrationTestWebBuzzoolaGroup();

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
   * Если переходим на базуллу, то этот компонент с этипи пропсами переносим в TGBBanner.
   * Если не переходим, то просто всё в этом компоненте удалится.
   */
  if (isBuzzoolaGroup) {
    return (
      <BuzzoolaBannerContainer
        hideOnError
        hideOnNoad
        position={position}
        placementId={isNewbuilding ? PLACEMENT_ID_NEWBUILDING : PLACEMENT_ID}
        sizes={SIZE}
        analyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    );
  }

  return (
    <AdFoxBannerContainer
      position={position}
      bannerName="Adfox ТГБ баннер"
      size={SIZE}
      pParams={isNewbuilding ? P_PARAMS_NEWBUILDING : P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    />
  );
};

/**
 * @todo Удалить компонент
 * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
 */
export const TGBBannerStub: FC<TGBBannerProps> = props => {
  const { isNewbuilding, position } = props;

  const { state, setTrue } = useBooleanState(false);

  if (state) {
    return (
      <BuzzoolaBannerContainer
        hideOnError
        hideOnNoad
        position={position}
        placementId={isNewbuilding ? PLACEMENT_ID_NEWBUILDING : PLACEMENT_ID}
        sizes={SIZE}
        analyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    );
  }

  return (
    <AdFoxBannerContainer
      position={position}
      bannerName="Adfox ТГБ баннер"
      onStub={setTrue}
      size={SIZE}
      pParams={isNewbuilding ? P_PARAMS_NEWBUILDING : P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    />
  );
};

export const TGBBanner = memo<TGBBannerProps>(function TGBBanner(props) {
  const { isNewbuilding, position } = props;

  const isBuzzoolaExpEnabled = useNewbuildingBuzzoolaIntegrationTestWebExpEnabled();
  const isBuzzoolaAsStubEnabled = useNewbuildingBuzzoolaIntegrationAsStubEnabled();
  const isBuzzoolaFirstEnabled = useNewbuildingBuzzoolaFirstEnabled();

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
   * Если переходим на базуллу, то выносим компонент базуллы BuzzoolaBannerWithHide сюда,
   * ветвление в любом случае удаляется, компонента TGBBannerExp не должно быть.
   */
  if (isBuzzoolaExpEnabled) {
    return <TGBBannerExp {...props} />;
  }

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
   * Тут логику ветвления полностью убираем, так как тут просто включение базулы на постоянной основе, а результатом будет эксперимент,
   * это для того, что бы можно было включить баннеры для тестирования и подобных кейсов
   */
  if (isBuzzoolaFirstEnabled) {
    return (
      <BuzzoolaBannerContainer
        hideOnError
        hideOnNoad
        position={position}
        placementId={isNewbuilding ? PLACEMENT_ID_NEWBUILDING : PLACEMENT_ID}
        sizes={SIZE}
        analyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    );
  }

  /**
   * @todo Удалить ветвление
   * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
   * Тут удаляем в любом случае, так как это промежуточная логика пилота, этой логики по планам не будет в стабильном коде.
   * Будет или только адфокс или базулла.
   */
  if (isBuzzoolaAsStubEnabled) {
    return <TGBBannerStub {...props} />;
  }

  return (
    <AdFoxBannerContainer
      position={position}
      bannerName="Adfox ТГБ баннер"
      size={SIZE}
      pParams={isNewbuilding ? P_PARAMS_NEWBUILDING : P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    />
  );
});
